import React from 'react';
import Button from './style';
import { useDispatch } from 'react-redux';
import { SignOutAction } from '../../../../redux/actions/user';

function ButtonLogout() {
  const dispatch = useDispatch();
  const handleClick = (e) => {
    e.preventDefault();
    dispatch(SignOutAction());
  };
  return (
    <Button>
      <a href="/" onClick={handleClick}>
        <img src="/images/icons/exit.svg" alt="sair" />
        <span>Sair</span>
      </a>
    </Button>
  );
}

export default ButtonLogout;
